import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    fetch("/api/posts")
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => { setPosts(data ?? []); setStatus("ready"); })
      .catch(() => setStatus("error"));
  }, []);

  return (
    <section className="section">
      <div className="section-header">
        <span className="section-label">Writing</span>
        <h2 className="section-title">Blog</h2>
        <p className="section-description">
          Notes on what I'm building, breaking, and learning.
        </p>
      </div>

      {status === "loading" && (
        <div className="loading"><div className="loading-spinner"></div>Loading posts…</div>
      )}
      {status === "error" && <p className="blog-empty">Couldn't load posts.</p>}
      {status === "ready" && posts.length === 0 && <p className="blog-empty">No posts yet.</p>}

      {status === "ready" && posts.length > 0 && (
        <div className="blog-list">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="blog-card">
              <time className="blog-card-date">
                {new Date(p.date).toLocaleDateString("en-US", {
                  year: "numeric", month: "short", day: "numeric",
                })}
              </time>
              <h3 className="blog-card-title">{p.title}</h3>
              <p className="blog-card-desc">{p.description}</p>
              {p.tags?.length > 0 && (
                <div className="project-tech">
                  {p.tags.map((t) => <span key={t} className="tech-tag">{t}</span>)}
                </div>
              )}
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
